import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import React, { useEffect } from 'react';
import LoadingSpinner from 'src/components/LoadingSpinner';
import StyledTableCell from 'src/components/table/StyledTableCell';
import StyledTableRow from 'src/components/table/StyledTableRow';
import { useFetch } from 'src/hooks/useFetch';
import { Modal } from '..';
import { RetryMessage } from '../../RetryMessage';

const boldText = { fontWeight: 700 };

function VerInformacionTicketModal(props) {
  const { open, close } = props;

  const isRequerimiento = /^R-\d+$/.test(props?.data?.codigo);

  const { fetch, loading, data, error } = useFetch();

  const onCloseModal = React.useCallback(() => {
    close();
  }, [close]);

  const getInformacion = React.useCallback(() => {
    fetch(
      `/tickets/${isRequerimiento ? 'requerimientos' : 'incidentes'}/${
        props?.data?.codigo
      }/informacion`,
    );
  }, [fetch, props.data.codigo, isRequerimiento]);

  useEffect(() => {
    getInformacion();
  }, [getInformacion]);

  return (
    <Modal
      title={`${isRequerimiento ? 'Requerimiento' : 'Incidente'}: ${
        props?.data.codigo
      }`}
      content={
        <>
          {loading && <LoadingSpinner />}
          {!loading && error && (
            <RetryMessage
              message="Ocurrió un error al intentar cargar la información."
              retry={getInformacion}
            />
          )}
          {!loading && !error && data && (
            <Table>
              <TableBody>
                <StyledTableRow>
                  <StyledTableCell sx={boldText}>Asunto</StyledTableCell>
                  <StyledTableCell>{data.asunto}</StyledTableCell>
                </StyledTableRow>
                <StyledTableRow>
                  <StyledTableCell sx={boldText}>Descripción</StyledTableCell>
                  <StyledTableCell
                    dangerouslySetInnerHTML={{ __html: data.descripcion }}
                  />
                </StyledTableRow>
                <StyledTableRow>
                  <StyledTableCell sx={boldText}>Servicio</StyledTableCell>
                  <StyledTableCell>{data.servicio}</StyledTableCell>
                </StyledTableRow>
                <StyledTableRow>
                  <StyledTableCell sx={boldText}>Subcategoría</StyledTableCell>
                  <StyledTableCell>{data.subcategoria}</StyledTableCell>
                </StyledTableRow>
                <StyledTableRow>
                  <StyledTableCell sx={boldText}>Impacto</StyledTableCell>
                  <StyledTableCell>{data.impacto}</StyledTableCell>
                </StyledTableRow>
                <StyledTableRow>
                  <StyledTableCell sx={boldText}>Urgencia</StyledTableCell>
                  <StyledTableCell>{data.urgencia}</StyledTableCell>
                </StyledTableRow>
                <StyledTableRow>
                  <StyledTableCell sx={boldText}>Solución</StyledTableCell>
                  <StyledTableCell>{data.solucion}</StyledTableCell>
                </StyledTableRow>
                {data.calificacion && (
                  <StyledTableRow>
                    <StyledTableCell sx={boldText}>
                      Calificación
                    </StyledTableCell>
                    <StyledTableCell>{data.calificacion}</StyledTableCell>
                  </StyledTableRow>
                )}
                <StyledTableRow>
                  <StyledTableCell sx={boldText}>Comentarios</StyledTableCell>
                  <StyledTableCell>{data.comentarios}</StyledTableCell>
                </StyledTableRow>
                <StyledTableRow>
                  <StyledTableCell sx={boldText}>
                    Última actualización
                  </StyledTableCell>
                  <StyledTableCell>{data.ultima_actualizacion}</StyledTableCell>
                </StyledTableRow>
              </TableBody>
            </Table>
          )}
        </>
      }
      open={open}
      close={onCloseModal}
      showConfirmButton={false}
      cancelButtonText="Cerrar"
    />
  );
}

export default VerInformacionTicketModal;
